export const initialState = () => ({
  subjectId: '',
  birthYear: null,
  gender: '',
  startDate: '',
});

export default initialState();
